import axios from "axios";

const lockUrl = (operation) =>
  `${process.env.REACT_APP_BASE_URL}/nocApi/forms/edit-lock/${operation}`;

export const acquireFormEditLock = async ({ currentSession, formId }) => {
  const response = await axios.post(
    lockUrl("acquire"),
    { currentSession, formId },
    { withCredentials: true },
  );
  const data = response?.data?.data || {};
  if (!response?.data?.success || !data.lockId) {
    throw new Error(
      response?.data?.message || "The inactive form editor lock could not be acquired",
    );
  }
  return {
    formId,
    lockId: data.lockId,
    heartbeatSeconds: data.heartbeatSeconds || 30,
  };
};

export const heartbeatFormEditLock = async ({
  currentSession,
  formId,
  lockId,
}) =>
  axios.post(
    lockUrl("heartbeat"),
    { currentSession, formId, lockId },
    { withCredentials: true },
  );

export const releaseFormEditLock = async ({ currentSession, formId, lockId }) =>
  axios.post(
    lockUrl("release"),
    { currentSession, formId, lockId },
    { withCredentials: true },
  );

export const formatFormEditLockedMessage = (error) => {
  const lockOwner = error?.response?.data?.data?.ownerEmail;
  const retryAfter = error?.response?.data?.data?.retryAfterSeconds;
  return `This form is already being edited${lockOwner ? ` by ${lockOwner}` : ""}.${retryAfter ? ` Try again in about ${retryAfter} seconds.` : ""}`;
};